import { render } from "./ChipMultiSelect.vue?vue&type=template&id=6e957ea3"
import script from "./ChipMultiSelect.vue?vue&type=script&lang=js"
export * from "./ChipMultiSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__